import * as React from 'react';

const OktatoRCRedirect = () => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    //useEffect(() => {
    

    //}, []); // Update if authState changes

    const RedirectToRC = () => {
        sessionStorage.removeItem("UserInfo");
        sessionStorage.removeItem("root");
        sessionStorage.removeItem('QueryTag');
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }
        window.location.href = "/";
    };
    return (
        <div className="preloaderColumn">
            <div className="rediret"> Okta sign-in is disallowed. You will now be redirected to the standard Maritime platform sign-in page at {window.location.origin}.</div>
           
            <button type="button" className='btn btn-primary mt-4' onClick={RedirectToRC}>OK</button>
        </div>
    );
};

export default OktatoRCRedirect;
